export default "__VITE_ASSET__a0552d6b__"